<template>
  <button @click="modalActive = true" class="flex justify-between items-center py-6 px-4">
    <div class="flex items-center gap-2">
      <svg-icon name="green-tick" class="w-4 h-4 text-blue-400" />
      <h2 class="h2">{{ title }}</h2>
    </div>
    <svg-icon name="info" class="w-4 h-4 text-blue-400" />
  </button>

  <vue-modal v-model="modalActive" @close="modalActive = false">
    <div class="modal-content max-w-xs! sm:max-w-lg! items-center! text-center! py-5! sm:py-10!">
      <img :src="imageSrc" :alt="title" width="115" height="120" />
      <h1 class="text-xl font-semibold sm:text-2xl text-green-400">
        {{ title }}
      </h1>
      <h2 class="text-lg sm:text-xl">{{ body }}</h2>
    </div>
  </vue-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
export interface Props {
  imageSrc: string;
  title: string;
  body: string;
}

const modalActive = ref(false)
defineProps<Props>()
</script>
